import { isDesktop } from '../defs';

export default function initLocalSiteListBlock() {
    [].slice.apply(document.querySelectorAll('.lstList')).forEach(initBlock);
}

/**
 *
 * @param {HTMLElement} el
 */
function initBlock(el) {
    const inputEl = el.querySelector('.lstList-searchInput');
    const notHitsTxtEl = el.querySelector('.lstList-noHitsTxt');

    if (!inputEl) {
        return;
    }

    const entries = [].slice.apply(el.querySelectorAll('.lstList-entry')).map(entryEl => {
        const btnEl = entryEl.querySelector('.lstList-entryBtn');
        const nestedEl = entryEl.querySelector('.lstList-entryNested');

        const listEl = nestedEl.querySelector('.lstList-entryList');

        const linkEls = [].slice.apply(entryEl.querySelectorAll('a'));
        const index = linkEls.map(a => {
            return {
                words: a.innerText.split(' ').map(s => s.trim().toLowerCase()).filter(s => s),
                linkEl: a,
            };
        });

        btnEl.addEventListener('click', toggle);

        function search(terms) {
            let hits = 0;
            let primaryHit = false;

            entryEl.classList.remove('has--hit');
            entryEl.classList.remove('no--hits');

            if (!terms || terms.every(t => !t)) {
                index.forEach(({ linkEl }) => {
                    linkEl.classList.remove('is--miss');
                    linkEl.classList.remove('is--hit');
                });
                // Idle states are different for mobile and desktop
                isDesktop() ? open() : close();
                return;
            }
            index.forEach(({
                               linkEl,
                               words,
                           }) => {
                const prevHits = hits;
                terms.forEach(term => {
                    words.forEach(word => {
                        if (word.indexOf(term) >= 0 || term.indexOf(word) >= 0) {
                            hits += 1;
                            linkEl.dataset.primary && (primaryHit = true);
                            linkEl.classList.remove('is--miss');
                            linkEl.classList.add('is--hit');
                            entryEl.classList.add('has--hit');
                        }
                    });
                });
                if (prevHits === hits) {
                    linkEl.classList.add('is--miss');
                    linkEl.classList.remove('is--hit');
                }
            });
            entryEl.classList.remove('has--primaryHit');
            entryEl.classList.remove('only--primaryHit');
            if (primaryHit) {
                entryEl.classList.add('has--primaryHit');
            }
            if (!hits) {
                entryEl.classList.add('no--hits');
                close();
            } else if (primaryHit && hits === 1) {
                entryEl.classList.add('only--primaryHit');
                isDesktop() || close();
            } else {
                open();
            }
            return hits;
        }

        function isOpen() {
            return nestedEl.classList.contains('is--open');
        }

        function toggle() {
            isOpen() ? close() : open();
        }

        function open() {
            nestedEl.classList.add('is--open');
            entryEl.classList.add('is--open');
            if (listEl) {
                nestedEl.style.height = listEl.scrollHeight + 'px';
            }
        }

        function close() {
            nestedEl.classList.remove('is--open');
            entryEl.classList.remove('is--open');
            nestedEl.style.height = '0';
        }

        function autoState() {
            if (isDesktop() && !isOpen()) {
                open();
            } else if (!isDesktop() && isOpen()) {
                close();
            }
        }

        return {
            btnEl,
            nestedEl,
            toggle,
            open,
            close,
            isOpen,
            search,
            resolveState: autoState,
        };
    });

    inputEl.addEventListener('keyup', event => doSearch());

    onResize();
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);

    function onResize() {
        entries.forEach(entry => {
            entry.resolveState();
        });
    }

    // Debounce search using counter, to avoid running multiple searches simultaneously
    let waitASec = 0;

    function doSearch() {
        if (waitASec) {
            waitASec += 1;
            return;
        }
        waitASec = 1;
        const terms = inputEl.value.split(' ').map(s => s.trim().toLowerCase()).filter(s => s);
        let hits = 0;
        entries.forEach(entry => {
            hits += entry.search(terms);
        });
        if (hits > 0) {
            el.classList.remove('no--hits');
        } else if (terms.length) {
            el.classList.add('no--hits');
            notHitsTxtEl.innerText = inputEl.value;
        }
        if (waitASec > 1) {
            waitASec = 0;
            doSearch();
        }
        waitASec = 0;
    }
}
